import { clientUrlPath, excludeAnchorFromUrl, excludeQueryStringFromUrl } from 'common/utilities/browser/url/url';
import { REDIRECT } from 'core/api/apiHelpers';
import * as I from 'core/api/coreApiClient';
import { configurationLoaded } from 'core/redux/actions/configuration/configurationActions';
import {
openNewWindowAction,   redirectAction, redirectToPageAction,
refreshPageAction, } from 'core/redux/actions/ui/uiActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AnyAction,Middleware } from 'redux';

const redirectMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  const { configuration: { jsfUrl }, user: { initAppAfterLogOut } } = store.getState() as ApplicationState;

  // Once the configuration is reloaded after a log out, redirect the user to the default_first_page_url
  // so the next user doesn't see the previous location
  if (configurationLoaded.match(action) && initAppAfterLogOut) {
    store.dispatch(
      redirectToPageAction(action.payload.configuration.default_first_page_url, true),
    );
  }

  if (redirectAction.match(action)) {
    switch (action.payload.redirect.redirectType) {
      case I.RedirectTypeConstants.JSFHREF:
        window.location.href = `${jsfUrl}${action.payload.redirect.redirectUri}`;
        break;
      case I.RedirectTypeConstants.HREF:
        if (
          excludeQueryStringFromUrl(excludeAnchorFromUrl(clientUrlPath(action.payload.redirect.redirectUri)))
          === excludeAnchorFromUrl(window.location.pathname)
        ) {
          store.dispatch(refreshPageAction());
        } else {
          store.dispatch(
            redirectToPageAction(
              action.payload.redirect.redirectUri,
              action.payload.responseStatus === REDIRECT
              && window.location.pathname.match('/show/') !== null,
            ),
          );
        }
        break;
      case I.RedirectTypeConstants.ExternalHREF:
        // GDBX launcher/protocol: don't open new - just empty - tab
        if (action.payload.redirect.redirectUri?.startsWith('gdbx:')) {
          window.location.href = action.payload.redirect.redirectUri;
        } else {
          window.open(action.payload.redirect.redirectUri);
        }
        break;
      default:
    }
  }

  if (openNewWindowAction.match(action)) {
    if (action.payload.url.startsWith('http')) {
      window.open(action.payload.url, '_blank');
    } else {
      window.open(`${jsfUrl}${action.payload.url}`, '_blank');
    }
  }

  next(action);
};

export default redirectMiddleware;
